const rquireMd5 = require('md5')

export function md5(date) {
    return rquireMd5(date)
}

export default {
    md5
}